import React from 'react';
import { Container } from 'bloomer/lib/layout/Container';
import { Box } from 'bloomer/lib/elements/Box';
import { RouteComponentProps } from '@reach/router';
import api from '../util/api';
import LocationCell from '../components/LocationCell';
import { Button } from 'bloomer/lib/elements/Button';
import { Icon } from 'bloomer/lib/elements/Icon';
import AddLocationModal from '../components/AddLocationModal';
import { Level } from 'bloomer/lib/components/Level/Level';
import MarginlessTitle from '../elements/MarginlessTitle';
import { LevelRight } from 'bloomer/lib/components/Level/LevelRight';
import { LevelItem } from 'bloomer/lib/components/Level/LevelItem';
import Spacer from '../elements/Spacer';

interface PropTypes extends RouteComponentProps<{}> {}
interface StateTypes {
  locations: ILocation[];
  isModalOpen: boolean;
}

class ManageLocations extends React.Component<PropTypes, StateTypes> {
  state: StateTypes = {
    locations: [],
    isModalOpen: false,
  };

  componentDidMount() {
    this.getLocations();
  }

  getLocations = async () => {
    const locations = await api.locations.get();
    this.setState({ locations });
  };

  toggleModal = () => {
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  };

  render() {
    const { locations, isModalOpen } = this.state;
    return (
      <Container>
        <Box>
          <Level>
            <MarginlessTitle isSize={1}>Manage Locations</MarginlessTitle>
            <LevelRight>
              <LevelItem>
                <Button
                  isColor="primary"
                  type="button"
                  onClick={this.toggleModal}
                  isLoading={isModalOpen}
                  disabled={isModalOpen}
                >
                  <Spacer>
                    <Icon className="fa fa-plus" />
                  </Spacer>
                  Add Location
                </Button>
              </LevelItem>
            </LevelRight>
          </Level>

          {locations.map((location, i) => (
            <LocationCell key={location._id} location={location} i={i} refresh={this.getLocations} />
          ))}
        </Box>
        <AddLocationModal isOpen={isModalOpen} handleClose={this.toggleModal} refresh={this.getLocations} />
      </Container>
    );
  }
}

export default ManageLocations;
